module.exports = __webpack_public_path__ + "static/img/nightShift.df22019d.svg";